var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.117,
    height: 16,
    viewBox: "0 0 8.117 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M64.834,44.486l-.265,2.227a.421.421,0,0,1-.421.375H61.832V53.7a.3.3,0,0,1-.295.3h-2.36a.3.3,0,0,1-.295-.3l.013-6.608H57.141a.421.421,0,0,1-.421-.421V44.44a.421.421,0,0,1,.421-.421h1.743v-2.16c0-2.5,1.486-3.859,3.663-3.859h1.783a.421.421,0,0,1,.421.421V40.3a.421.421,0,0,1-.421.421H63.238c-1.183.019-1.406.585-1.406,1.432v1.863h2.592a.421.421,0,0,1,.411.474Z",
    transform: "translate(-56.72 -38)",
    fill: "#334c8c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.120d78da8d508bf1317225484c25df7e.svg";
export { ForwardRef as ReactComponent };